import { useDispatch } from 'react-redux'
import { AppDispatch, useRoutes } from '../../../store'
import Table from '../../common/Table'
import Wrapper from '../../common/Wrapper'
import { getTableConfig } from './tableConfig'
import { AdBreak, Role, type User } from 'common/api/v1/types'
import CommonActions from './CommonActions'
import { MissingContent } from '../../common/MissingContent'
import { useAdBreaksSelector, usePageParams, useUser, withDefaultPagination } from '../../../utils'
import { useNavigate } from 'react-router'

export const canViewAdBreak = (groupId: string, user: User) => {
  return (user.role === Role.admin && groupId === user.group) || user.role === Role.super
}

export const AdBreakList = () => {
  const dispatch = useDispatch<AppDispatch>()
  const [params] = usePageParams()
  const navigate = useNavigate()
  const routes = useRoutes()
  const user = useUser()

  const { adBreaks, total, loading } = useAdBreaksSelector(withDefaultPagination(params))

  return (
    <>
      <Wrapper name={['Ad Insertion', 'Ad Breaks']}>
        <CommonActions />
        <Table<AdBreak>
          id={'ad-breaks-table'}
          emptyMessageComponent={<MissingContent message="No ad breaks" />}
          data={adBreaks}
          pagination={{
            total: total,
            useUrlSearchParams: true,
          }}
          config={getTableConfig({ dispatch })}
          pending={loading}
          rowProps={({ id, groupId }) => {
            return {
              onDoubleClick: () => (canViewAdBreak(groupId, user) ? void navigate(routes.adBreaksView({ id })) : null),
              tabIndex: -1,
            }
          }}
        />
      </Wrapper>
    </>
  )
}
